export enum ClearButtonVisible {
  NO = "no",
  WHEN_FOCUSED = "when_focused",
  YES = "yes"
}